"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var readyState = /complete|loaded|interactive/;
exports.ready = function (handler, context) {
    if (context === void 0) { context = document; }
    if (context.body instanceof Element &&
        readyState.test(context.readyState)) {
        setTimeout(handler, 0);
    }
    else {
        context.addEventListener("DOMContentLoaded", handler, false);
    }
};
